import { render, staticRenderFns } from "./workcenter-cosmetic-inspection.vue?vue&type=template&id=546d81d4&"
import script from "./js/workcenter-cosmetic-inspection.js?vue&type=script&lang=js&"
export * from "./js/workcenter-cosmetic-inspection.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports